import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useKoffieNav } from './KoffieApp';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: 'Jost', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #8a8780;
  margin-bottom: 20px;
  transition: color 0.15s;
  &:hover { color: #0c0c0b; }
`;

export default function KoffieBackButton({ to = '/Koffiereparatie/settings' }) {
  const navigate = useNavigate();
  const { handleNavigation } = useKoffieNav();
  return (
    <Button onClick={() => handleNavigation(() => navigate(to))}>
      <ArrowLeft size={14} />
      Terug
    </Button>
  );
}
